import { CheckedState } from '@radix-ui/react-checkbox'
import { isArray, isNil } from 'lodash-es'
import { ComponentProps } from 'react'

import {
  type FieldOnChange,
  FormControl,
  FormField,
  useFormField,
} from './form'
import * as Checkbox from '../checkbox'

type CheckboxFieldValue = string | boolean | (string | boolean)[]

type CheckboxProps = ComponentProps<typeof Checkbox.Root> & {
  value?: string | boolean
  weight?: ComponentProps<typeof Checkbox.Label>['weight']
}

export const FormCheckbox = ({
  value: valueProp,
  weight,
  children,
  ...props
}: CheckboxProps) => {
  const { name } = useFormField()

  const isChecked = (fieldValue: string | boolean | (string | boolean)[]) => {
    if (!isNil(valueProp) && Array.isArray(fieldValue)) {
      return fieldValue.includes(valueProp)
    }

    return fieldValue as boolean
  }

  const handleChange =
    (value: CheckboxFieldValue, onChange?: FieldOnChange) =>
    (checked: CheckedState) => {
      if (!onChange) return

      if (!isArray(value)) {
        onChange(checked)
      } else {
        if (checked) {
          onChange([...value, valueProp])
        } else {
          onChange(value.filter(item => item !== valueProp))
        }
      }
    }

  return (
    <FormField name={name}>
      <FormControl
        render={({ id, value, onChange, ...formProps }) => (
          <Checkbox.Label htmlFor={id} size={props.size} weight={weight}>
            <Checkbox.Root
              checked={isChecked(value)}
              onCheckedChange={handleChange(value, onChange)}
              id={id}
              {...formProps}
              {...props}
            />
            {children}
          </Checkbox.Label>
        )}
      />
    </FormField>
  )
}
